module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl2-75.359f41d2.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl2-75.png
// module id = 3350
// module chunks = 11